import { render, staticRenderFns } from "./AnalyticsDisposal.vue?vue&type=template&id=1c498388&scoped=true&"
import script from "./AnalyticsDisposal.vue?vue&type=script&lang=js&"
export * from "./AnalyticsDisposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c498388",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
